import(/* webpackMode: "eager", webpackExports: ["GenericQuiz"] */ "/vercel/path1/app/[examType]/quiz/quiz-client.tsx");
